import React from 'react';

import DatetimeInput from 'ui-library/inputs/DatetimeInput';
import {DatetimeFieldProps, LABEL_STYLES, Size, SIZES} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import {
  DATETIME_FORMATS,
  PRESENTATIONAL_LOCAL_DATETIME_FORMAT,
  PRESENTATIONAL_TIME_FORMAT,
  USER_EDIT_TIME_FORMAT,
} from 'util/DateConstants';
import uniqueId from 'util/uniqueId';

export const DATEPICKER_CUSTOM_INPUT_USER_EDIT_FORMAL_TIME_FORMATS = ['hh:mm a', 'hh:mma'];
export const DATEPICKER_CUSTOM_INPUT_USER_EDIT_INFORMAL_TIME_FORMATS = [
  USER_EDIT_TIME_FORMAT,
  'h:ma',
  'ha',
  'h a',
];

export default function DatetimeField({
  isRequired = false,
  labelStyle = LABEL_STYLES.LABEL,
  size = Size.SMALL,
  isDisabled = false,
  autoFocus = false,
  label = 'Datetime',
  placeholder = 'YYYY-MM-DD hh:mm:ss AM/PM',
  validDatetimeInputFormats = DATETIME_FORMATS,
  datetimePresentationalFormat = PRESENTATIONAL_LOCAL_DATETIME_FORMAT,
  timeInputPlaceholder = 'hh:mm AM/PM',
  timeInformalInputFormats = DATEPICKER_CUSTOM_INPUT_USER_EDIT_INFORMAL_TIME_FORMATS,
  timeFormalInputFormats = DATEPICKER_CUSTOM_INPUT_USER_EDIT_FORMAL_TIME_FORMATS,
  timePresentationalFormat = PRESENTATIONAL_TIME_FORMAT,
  ...props
}: DatetimeFieldProps): JSX.Element {
  const id = uniqueId('datetimeField-');

  return (
    <InputWrapper
      button={props.button}
      className={props.className}
      description={props.description}
      dataTestAttrs={props.dataTestAttrs}
      id={id}
      isRequired={isRequired}
      label={label}
      labelStyle={labelStyle}
      size={size}
      help={props.help}
    >
      <DatetimeInput
        autoFocus={autoFocus}
        className={props.inputClassName}
        wrapperClassName={props.wrapperClassName}
        hasButton={Boolean(props.button)}
        max={props.max}
        min={props.min}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        placeholder={placeholder}
        size={size}
        value={props.value ? props.value : ''}
        datePickerPopperContainerSelector={props.datePickerPopperContainerSelector}
        validDatetimeInputFormats={validDatetimeInputFormats}
        datetimePresentationalFormat={datetimePresentationalFormat}
        timeInputPlaceholder={timeInputPlaceholder}
        timeInformalInputFormats={timeInformalInputFormats}
        timeFormalInputFormats={timeFormalInputFormats}
        timePresentationalFormat={timePresentationalFormat}
        datetimePickerRef={props.datetimePickerRef}
        preventDefault={props.preventDefault}
        isDisabled={isDisabled}
      />
    </InputWrapper>
  );
}

DatetimeField.SIZES = SIZES;
DatetimeField.LABEL_STYLES = LABEL_STYLES;
